// ─── @mop/feature-inventory — module « inventory » ────────────────
// Une app le monte avec un `mode` : 'edit' (My Inventory) ou 'readonly'
// (MoPCal, qui consulte le stock sans jamais le modifier).
//   <EcranInventaires mode="edit" />
//   <EcranPlans mode="readonly" />
//
// Le module ne dépend QUE de @mop/core (règle d'indépendance des modules).
// Le tenant vient de useEspace() du Core — le module ne connaît pas les
// calendriers, ni aucune notion propre à MoPCal.
//
// Sous-modules couverts : inv-inventaires, inv-objets, inv-emplacements,
// inv-plans, inv-comptage, inv-scan, inv-photos, inv-io, inv-referentiel.
// Les modules natifs (caméra, galerie, impression, fichiers) sont chargés
// PARESSEUSEMENT : une app qui ne les installe pas perd la fonction, pas plus.

// Catalogue des fonctions du module (pour <FonctionsProvider catalogue={…}>).
export { FONCTIONS_INVENTAIRE } from './fonctions';

// Écrans
export { default as EcranInventaires } from './EcranInventaires';
export { default as EcranInventaire }  from './EcranInventaire';
export { default as EcranPlans }       from './EcranPlans';

// Section de Profil : « qui voit quoi » pour les inventaires et les plans
export { default as SectionAccesInventaire } from './SectionAccesInventaire';

// Feuilles et briques réutilisables
export { default as FeuilleElement, etatDepuisItem, itemDepuisEtat } from './FeuilleElement';
export { default as FicheElement } from './FicheElement';
export { default as LocalisationModal } from './LocalisationModal';
export { default as FeuilleTransfert } from './FeuilleTransfert';
export { default as FeuilleProprietes } from './FeuilleProprietes';
export { default as PlanGrid }         from './ui/PlanGrid';
export { default as PhotosArticle }    from './ui/PhotosArticle';
export { default as ScannerCodeBarres } from './ui/ScannerCodeBarres';

// Services
export * from './services/inventaires';
export * from './services/plan';
export * from './services/plansData';
export * from './services/produits';
export * from './services/io';
export * from './services/qr';
export { exporterInventairePdf, genererInventaireHTML, prechargerPhotosPdf } from './services/pdf';
export { MODELES_INVENTAIRE, instancierModele, nbCategoriesModele } from './data/templates';
export { PRATIQUES_INVENTAIRE } from './pratiques';
